import { useFormikContext } from 'formik';
import React, { useState, useEffect } from 'react'
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";

// Capitalize first letter of each word in a name
const capitalizeWords = (str) => {
  if (!str) return str;
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('-');
};

// Fields that should have name capitalization applied
const NAME_FIELDS = ['surname', 'otherNames', 'previousSurname', 'firstName', 'lastName', 'middleName', 'othernames', 'othername'];

export default function Input({type, name, label, placeholder, inputLength, value, index, capitalizeNames = true}) {
  const { values, handleChange, setFieldValue, errors }  = useFormikContext()
  const [err, setErr] = useState(false)


  const getErrorMessage = (name) => {
    if(errors?.education?.[index]){
      const key = name.split(`[${index}].`)[1]
      return errors?.education?.[index][key]
    }

    return errors[name]
  }

  // Check if this field should have name capitalization
  const shouldCapitalize = capitalizeNames && NAME_FIELDS.some(field =>
    name === field || name.toLowerCase().includes(field.toLowerCase())
  );

  const handleBlur = (e) => {
    if(errors[name]){
      setErr(true)
    }

    // Auto-capitalize name fields on blur
    if (shouldCapitalize && e.target.value) {
      const capitalizedValue = capitalizeWords(e.target.value);
      if (capitalizedValue !== e.target.value) {
        setFieldValue(name, capitalizedValue);
      }
    }
  };


  return (
    <FloatingLabel label={label} className="mb-3">
      <Form.Control
        type={type}
        name={name}
        maxLength={inputLength && inputLength}
        value={ value ?? values[name] ?? ''}
        onChange={ handleChange }
        onBlur={handleBlur}        
        isInvalid={err && errors[name]}
        isValid={values[name] && !errors[name]}
        placeholder={placeholder}
      />
      <Form.Control.Feedback type="invalid" className={ `text-danger ${Number.isInteger(index) && "d-block"}`} >
        { getErrorMessage(name) }
      </Form.Control.Feedback>
    </FloatingLabel>
  )
}

